import type { ViewId } from 'balus-common';
import type { ViewName } from '@view-model/domain/view';
import type { Rect } from '@view-model/models/common/basic/Rect';
import { BaseTitleBar } from './BaseTitleBar';
import type { ThemeColor } from '@view-model/models/common/color';
import type { GetGuardProps } from '@model-framework/drag-file/useDragFileGuard';

type Props = {
  viewRect: Rect;
  name: ViewName;
  viewId: ViewId;
  isLocked: boolean;
  onCopyView: () => void;
  onOpenPopupMenu: () => void;
  onAddMeaningPanel: () => void;
  onToggleMeaningPanel: () => void;
  onToggleShowNodeCreatedUser: () => void;
  width: number;
  height: number;
  margin: number;
  menuContainerWidth: number;
  shouldHideMenuButtons: boolean;
  viewThemeColor: ThemeColor;
  readonly: boolean;
  hasMeaningPanel: boolean;
  getGuardProps: GetGuardProps;
};

export const ReadonlyTitleBar = ({
  viewRect,
  name,
  viewId,
  isLocked,
  onCopyView,
  onOpenPopupMenu,
  onAddMeaningPanel,
  onToggleMeaningPanel,
  onToggleShowNodeCreatedUser,
  width,
  height,
  margin,
  menuContainerWidth,
  shouldHideMenuButtons,
  viewThemeColor,
  readonly,
  hasMeaningPanel,
  getGuardProps,
}: Props) => {
  return (
    <g transform={viewRect.topLeft().toSVGTranslate()}>
      <BaseTitleBar
        width={width}
        height={height}
        margin={margin}
        menuContainerWidth={menuContainerWidth}
        shouldHideMenuButtons={shouldHideMenuButtons}
        viewThemeColor={viewThemeColor}
        name={name}
        viewId={viewId}
        readonly={readonly}
        isLocked={isLocked}
        hasMeaningPanel={hasMeaningPanel}
        onCopyView={onCopyView}
        onOpenPopupMenu={onOpenPopupMenu}
        onAddMeaningPanel={onAddMeaningPanel}
        onToggleMeaningPanel={onToggleMeaningPanel}
        onToggleShowNodeCreatedUser={onToggleShowNodeCreatedUser}
        getGuardProps={getGuardProps}
      />
    </g>
  );
};
